import { PAYMENT_GATEWAY_MAP } from "@shared/constants/enums";
import { PaymentServiceBasket } from "../../services/useBasketPaymentService";

/**
 * Checks if a basket's payment_gateway can be considered to be of type Authorize
 */
export function isAuthorizeBasketGateway(basket: PaymentServiceBasket) {
  return Boolean(
    basket.paymentGateway &&
      basket.paymentGateway.gateway_type ===
        PAYMENT_GATEWAY_MAP.GATEWAY_AUTHNET.id
  );
}
